import { render } from "./SideFilter.html?vue&type=template&id=36fc172b&scoped=true&ts=true&external"
import script from "./SideFilter.vue?vue&type=script&lang=ts"
export * from "./SideFilter.vue?vue&type=script&lang=ts"

import "./SideFilter.scss?vue&type=style&index=0&id=36fc172b&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fc172b"]])

export default __exports__